import { useContext } from 'react';
import { PortalContext } from '../context/portal-context';
import { Discount } from '@esportal/portal-service';

export const discountHelper = () => {
	const { portalService } = useContext(PortalContext);

	const discounts = portalService?.getPersonBenefits().getValue()?.benefits.discounts || [];
	const discountIds = discounts.map((discount) => discount.id);

	const getDiscountById = (id: string): Discount | undefined => {
		return discounts.find((discount) => discount.id === id);
	};

	const hasDiscount = (id: string): boolean => {
		return discountIds.includes(id);
	};

	const getDiscountOrFallback = (primaryId: string, fallbackId: string): Discount | undefined => {
		return getDiscountById(primaryId) || getDiscountById(fallbackId) || discounts[0];
	};

	const formatNumberWithThousands = (value: string | number): string => {
		const numericValue = typeof value === 'string' ? parseFloat(value) : value;

		if (isNaN(numericValue)) {
			return '0';
		}
		return Math.floor(numericValue).toLocaleString('es-ES', {
			useGrouping: true,
			minimumFractionDigits: 0,
			maximumFractionDigits: 0,
		});
	};

	return {
		discounts,
		discountIds,
		getDiscountById,
		hasDiscount,
		getDiscountOrFallback,
		formatNumberWithThousands,
	};
};
